export const borrowerDefaults = {
  personalGuarantor: true,
};

export const isBorrowerPersonGuarantor = (
  pctOwnership: number
) => {
  return !!(pctOwnership && !isNaN(pctOwnership) && pctOwnership > 20);
};

export const formatBorrowerExperience = (exp) => {
  if (exp == '6') {
    return '5+'
  }
  return exp;
}